<div class="container">
  @if (!hideText()) {
    <div class="title line-clamp-2">
      <cue-icon [icon]="ICONS.cueQrScan" class="scan-icon" />

      @if (qrCodeCustomTextNoLocalization()) {
        {{ qrCodeCustomTextNoLocalization() }}
      } @else {
        {{
          (qrCodeCustomText() | localizedString)
            ? (qrCodeCustomText() | localizedString)
            : (translation.wayfinding.continueWithWebNav | transloco)
        }}
      }
    </div>
  }
  @if (hasOverlayIcon) {
    <div class="qrcode-wrapper">
      <kendo-qrcode [value]="currentUriData()" errorCorrection="L" class="qr-code" [size]="270" />
      <div class="overlay">
        <img class="overlay-icon" src="/assets/images/click-finger.png" />
      </div>
    </div>
  } @else {
    <kendo-qrcode [value]="currentUriData()" errorCorrection="L" class="qr-code" [size]="270" />
  }
</div>
